import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {
    EenCustomerAccountListResponse,
    EenCustomerAccountOrganizationAssignmentPayload,
    EenCustomerAccountOrganizationAssignmentResponse,
} from '../../models/vision-provider-management';

@Injectable({
    providedIn: 'root',
})
export class EenCustomerAccountApiService {
    private readonly baseUrl = `${environment.baseUrl}een-customer-accounts/`;

    constructor(private http: HttpClient) {
    }

    list(): Observable<EenCustomerAccountListResponse> {
        return this.http.get<EenCustomerAccountListResponse>(this.baseUrl);
    }

    getOrganizationAssignments(
        eenAccountId: string,
    ): Observable<EenCustomerAccountOrganizationAssignmentResponse> {
        return this.http.get<EenCustomerAccountOrganizationAssignmentResponse>(
            `${this.baseUrl}${encodeURIComponent(eenAccountId)}/organizations/`,
        );
    }

    saveOrganizationAssignments(
        eenAccountId: string,
        payload: EenCustomerAccountOrganizationAssignmentPayload,
    ): Observable<EenCustomerAccountOrganizationAssignmentResponse> {
        return this.http.put<EenCustomerAccountOrganizationAssignmentResponse>(
            `${this.baseUrl}${encodeURIComponent(eenAccountId)}/organizations/`,
            payload,
        );
    }
}
